export default __webpack_public_path__ + "static/media/cerebral_cortex_mask.d6963f66.png";